// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"414":"8caa36bf","796":"9716703a"}[chunkId] + ".chunk.css";
};